export default __webpack_public_path__ + "static/og-image-20a643b9afe9944e83849be425f4bb55.jpg";